import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_MealSubsidyType } from "../shared/data.service";
import { IntStringRequest } from "../shared/IntStringRequest";
import { MealSubsidyModifyRequest } from "../shared/MealSubsidyModifyRequest";

@Component({
	selector: "app-district-modify-meal-subsidy",
	templateUrl: "./district-modify-meal-subsidy.component.html",
	styleUrls: ["./district-modify-meal-subsidy.component.css"],
})
export class DistrictModifyMealSubsidyComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private MealSubsidyTypeService: DataService_MealSubsidyType
	) {}

	ngOnInit(): void {
		//
		// Get data from parent
		//

		this.EditMode = this.dialogConfig.data.EditMode;

		if (this.EditMode == true) {
			this.MealSubsidyTypeID = this.dialogConfig.data.MealSubsidyTypeID;
			this.MealSubsidyTypeCD = this.dialogConfig.data.MealSubsidyTypeCD;
			this.MealSubsidyTypeDesc = this.dialogConfig.data.MealSubsidyTypeDesc;
			this.MealSubsidyPct = this.dialogConfig.data.MealSubsidyPct;
		}
	}

	/////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////

	EditMode: any = false;
	MealSubsidyTypeID: any = -1;

	MealSubsidyTypeCD: any = "";
	MealSubsidyTypeDesc: any = "";
	MealSubsidyPct: any = 0;

	processing: any = false;
	errorMessage: any = "";

	/////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////////////
	onAdd() {
		//
		// Error handling
		//

		if (this.MealSubsidyPct < 0) {
			this.MealSubsidyPct = 0;
		} else if (this.MealSubsidyPct > 100) {
			this.MealSubsidyPct = 100;
		}

		if (this.MealSubsidyTypeCD == "") {
			this.errorMessage = "Enter Subsidy Code/Abbreviation";
			return;
		} else if (this.MealSubsidyTypeDesc == "") {
			this.errorMessage = "Enter Subsidy Description/Name";
			return;
		} else {
			this.CheckCD();
		}
	}

	CheckCD() {
		let parms: IntStringRequest = {
			num: this.MealSubsidyTypeID,
			str: this.MealSubsidyTypeCD,
		};

		var result = this.MealSubsidyTypeService.MealSubsidyTypeCDUsed(parms);
		result.subscribe(
			(response) => {
				if (!response) {
					this.CheckDesc();
				} else {
					this.errorMessage = "ERROR: Meal Subsidy Code already in use";
				}
			},
			(error) => {
				this.errorMessage = "ERROR checking Meal Subsidy Code";
			}
		);
	}

	CheckDesc() {
		let parms: IntStringRequest = {
			num: this.MealSubsidyTypeID,
			str: this.MealSubsidyTypeDesc,
		};

		var result = this.MealSubsidyTypeService.MealSubsidyTypeDescUsed(parms);
		result.subscribe(
			(response) => {
				if (!response) {
					if (this.EditMode == false) {
						this.FinishAdd();
					} else {
						this.FinishEdit();
					}
				} else {
					this.errorMessage = "ERROR: Meal Subsidy Description already in use";
				}
			},
			(error) => {
				this.errorMessage = "ERROR checking Meal Subsidy Description";
			}
		);
	}

	FinishAdd() {
		//
		// Create Request
		//

		let parms: MealSubsidyModifyRequest = {
			MealSubsidyTypeID: this.MealSubsidyTypeID,
			MealSubsidyTypeCD: this.MealSubsidyTypeCD,
			MealSubsidyTypeDesc: this.MealSubsidyTypeDesc,
			MealSubsidyPct: this.MealSubsidyPct.toString(),
		};

		//
		// Call SP
		//
		var result = this.MealSubsidyTypeService.MealSubsidyTypeInsert(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "modify",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Meal Subsidy Type Added Successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "modify",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not add the Meal Subsidy Type",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	FinishEdit() {
		//
		// Create Request
		//

		let parms: MealSubsidyModifyRequest = {
			MealSubsidyTypeID: this.MealSubsidyTypeID,
			MealSubsidyTypeCD: this.MealSubsidyTypeCD,
			MealSubsidyTypeDesc: this.MealSubsidyTypeDesc,
			MealSubsidyPct: this.MealSubsidyPct.toString(),
		};

		//
		// Call SP
		//
		var result = this.MealSubsidyTypeService.MealSubsidyTypeUpdate(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "modify",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Meal Subsidy Type Updated Successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "modify",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the Meal Subsidy Type",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	/////////////////////////////////////////////////////////////////
}
